import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { Grid } from '@mui/material'
import { cx } from '@emotion/css'
import { object } from 'prop-types'
import ProductOptions from '../../../molecules/product-options'
import ButtonsAction from './buttons-action'
import RelatedAttributes from './related-attributes'
import SidebarBottom from './sidebar-bottom'
import { OptionsWrapper, Root } from './sidebar-grouped.styled'
import SidebarTop from './sidebar-top'
import { forwardRef } from 'react'

const SidebarGroupedProduct = forwardRef(function SidebarGroupedProduct(
	{ className, reviewsRef = null, ...props },
	ref
) {
	const {
		catalog: {
			products: { optionsColumns },
		},
	} = useConfig()

	return (
		<Root className={cx('SidebarGroupedProduct-root', className)} ref={ref} {...props}>
			<SidebarTop titleProps={{ variant: 'h1' }} reviewsRef={reviewsRef} />

			<OptionsWrapper columns={optionsColumns}>
				<RelatedAttributes />
				<ProductOptions />
			</OptionsWrapper>

			<Grid item>
				<ButtonsAction />
			</Grid>

			<SidebarBottom />
		</Root>
	)
})

SidebarGroupedProduct.propTypes = {
	reviewsRef: object,
}

export default SidebarGroupedProduct
